
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/agreement",
      function () {
        return require("private-next-pages/agreement/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/agreement"])
      });
    }
  